import React from "react";
import { STATUS_OPTIONS } from "../lib/api";

export default function StatusToggle({ value, onChange, compact = false, disabled = false }) {
  return (
    <div
      className={`inline-flex flex-wrap gap-1 ${compact ? "" : "gap-2"}`}
      data-testid="status-toggle-group"
    >
      {STATUS_OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && onChange(opt.value)}
            data-testid={`status-toggle-${opt.value}`}
            className={`status-toggle px-3 py-1 text-[10px] uppercase tracking-[0.15em] font-medium rounded-full border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
              active
                ? "bg-neutral-900 text-white"
                : "bg-transparent text-neutral-500 border-neutral-800 hover:border-neutral-700 hover:text-neutral-300"
            }`}
            style={active ? { borderColor: opt.color, color: opt.color } : {}}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
